/* eslint-disable import/prefer-default-export */
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';

export const SkeletonLoading = ({ width = '', height = '', circle = false }) => (
  <Skeleton
    highlightColor="#565656"
    baseColor="#191919"
    width={width}
    height={height}
    circle={circle}
  />
);

SkeletonLoading.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circle: PropTypes.bool,
};
